
import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import '../../scss/Navmenudetail.scss'
import { FaLock, FaMinus, FaPlus } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";
import { isExamTypeCompleted } from 'utils/examProgress';

// Danh sách tất cả các dạng thi
const EXAM_TYPES = [
    { code: 'NOI', name: 'Speaking' },
    { code: 'NGUPHAP', name: 'Grammar and Vocabulary' },
    { code: 'NGHE', name: 'Listening' },
    { code: 'DOC', name: 'Reading' },
    { code: 'VIET', name: 'Writing' }
];

export default function Navmenudetail(props) {
    const { visible, onClose, type, indexDF, openMenuLeft, arrIdQuestion: arrIdQuestionProp, arrcautraloi: arrcautraloiProp, socauhoi: socauhoiProp, arrBook: arrBookProp } = props;
    var userId = localStorage.getItem('User_Id');
    var arrBookMark = localStorage.getItem('arrBookMark');
    var IdDeThi = localStorage.getItem('IdDeThi');
    const examMode = localStorage.getItem('exam_mode'); // 'speaking_only' or 'full_exam'

    const normalizeBook = (list) => (Array.isArray(list) ? list.map(item => (typeof item === 'object' ? item : String(item))) : []);
    const [arrBook, setArrBook] = useState(arrBookMark ? normalizeBook(JSON.parse(arrBookMark)) : []);
    const [arrBookNew, setarrBookNew] = useState([]);
    const [showQuestion, setshowQuestion] = useState({});
    const [examData, setExamData] = useState({}); // Lưu data cho tất cả các dạng thi: { NGUPHAP: { arrIdQuestion: [], arrcautraloi: [] }, ... }
    const [loading, setLoading] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const renderTitle = (examType) => {
        const examTypeToCheck = examType || type;
        if (examTypeToCheck == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (examTypeToCheck == "NGHE") {
            return "Listening";
        }
        else if (examTypeToCheck == "DOC") {
            return "Reading";
        }
        else if (examTypeToCheck == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }

    const getExamTypeRoute = (examType) => {
        if (examType === 'NGUPHAP') return '/startexamgrammar';
        if (examType === 'NGHE') return '/startexam';
        if (examType === 'DOC') return '/startexam';
        if (examType === 'NOI') return '/startexamnoi';
        if (examType === 'VIET') return '/startexamviet';
        return '/startexam';
    }

    // Đồng bộ dữ liệu dạng thi hiện tại từ props vào examData
    useEffect(() => {
        if (type && Array.isArray(arrIdQuestionProp)) {
            setExamData(prev => ({
                ...prev,
                [type]: {
                    arrIdQuestion: arrIdQuestionProp,
                    arrcautraloi: Array.isArray(arrcautraloiProp) ? arrcautraloiProp : [],
                    socauhoi: typeof socauhoiProp === 'number' ? socauhoiProp : arrIdQuestionProp.length
                }
            }));
        }
    }, [type, arrIdQuestionProp, arrcautraloiProp, socauhoiProp]);

    useEffect(() => {
        // Ưu tiên prop nếu có, fallback localStorage
        if (arrBookProp) {
            setArrBook(normalizeBook(arrBookProp));
        } else {
            var arrBookMark = localStorage.getItem('arrBookMark');
            const parsedBookMark = arrBookMark ? normalizeBook(JSON.parse(arrBookMark)) : [];
            setArrBook(parsedBookMark);
        }
    }, [arrBookProp]);

    useEffect(() => {
        // Khi mở menu hoặc examData thay đổi, sync bookmark + tính lại danh sách
        var arrBookMark = localStorage.getItem('arrBookMark');
        const parsedBookMark = arrBookProp ? normalizeBook(arrBookProp) : (arrBookMark ? normalizeBook(JSON.parse(arrBookMark)) : []);
        setArrBook(parsedBookMark);

        // Tính toán bookmarked cho tất cả các dạng thi
        let allBookmarked = [];
        Object.keys(examData).forEach(examType => {
            if (examData[examType] && examData[examType].arrIdQuestion) {
                const arr = findIndexInParentArray(examData[examType].arrIdQuestion, parsedBookMark);
                arr.forEach(item => {
                    allBookmarked.push({ ...item, examType });
                });
            }
        });
        setarrBookNew(allBookmarked);
    }, [visible, examData, arrBookProp]);

    useEffect(() => {
        if (visible) {
            loadCurrentExamData();
        }
    }, [visible])

    function findIndexInParentArray(parentArray, childArray) {
        return childArray.map(childItem => {
            if (typeof childItem === 'object') {
                // Nếu phần tử là đối tượng, tìm đối tượng tương ứng trong mảng cha
                let index = parentArray.findIndex(parentItem =>
                    typeof parentItem === 'object' && parentItem.idnhom === childItem.idnhom
                );
                return index !== -1 ? { value: childItem, index: index } : null;
            }
            const childVal = String(childItem);
            let index = parentArray.findIndex(parentItem =>
                typeof parentItem !== 'object' && String(parentItem) === childVal
            );
            return index !== -1 ? { value: childItem, index: index } : null;
        }).filter(result => result !== null);
    }

    // Chỉ load dạng current để tối ưu performance
    const loadCurrentExamData = async () => {
        const kyThiId = localStorage.getItem('CaThiId') || localStorage.getItem('KyThiId') || null;

        // Khởi tạo state expand cho mỗi dạng thi (mặc định expand dạng thi hiện tại)
        const newShowQuestion = {};
        const newLoading = {};
        EXAM_TYPES.forEach(examType => {
            newShowQuestion[examType.code] = examType.code === type;
            // Chỉ set loading = true cho dạng current nếu chưa có dữ liệu
            const hasDataFromState = examData[examType.code] && examData[examType.code].arrIdQuestion && examData[examType.code].arrIdQuestion.length > 0;
            const hasDataFromProps = examType.code === type && Array.isArray(arrIdQuestionProp) && arrIdQuestionProp.length > 0;
            newLoading[examType.code] = examType.code === type && !hasDataFromState && !hasDataFromProps;
        });
        setshowQuestion(newShowQuestion);
        setLoading(newLoading);

        // Chỉ load data cho dạng current nếu chưa có dữ liệu từ props hoặc state
        if (type) {
            // Kiểm tra xem đã có dữ liệu từ props chưa
            const hasDataFromProps = Array.isArray(arrIdQuestionProp) && arrIdQuestionProp.length > 0;
            const hasDataFromState = examData[type] && examData[type].arrIdQuestion && examData[type].arrIdQuestion.length > 0;

            if (hasDataFromProps || hasDataFromState) {
                // Đã có dữ liệu từ props hoặc state, không cần load lại
                setLoading(prev => ({
                    ...prev,
                    [type]: false
                }));
                return;
            }

            // Chưa có dữ liệu, cần load từ API
            try {
                let body = {
                    typeExam: type,
                    isthitructuyen: 1,
                    userId: userId,
                    IdDeThi: IdDeThi,
                    kyThiId: kyThiId
                };
                let result = await ThiTrucTuyenService.getdetailexam(body);
                const dataId = result?.data?.dataId || [];
                const datacautraloi = result?.data?.datacautraloi || [];

                // Cập nhật chỉ dạng current
                setExamData(prev => ({
                    ...prev,
                    [type]: {
                        arrIdQuestion: dataId,
                        arrcautraloi: datacautraloi,
                        socauhoi: dataId.length
                    }
                }));
            } catch (error) {
                console.error(`Error loading data for ${type}:`, error);
                setExamData(prev => ({
                    ...prev,
                    [type]: {
                        arrIdQuestion: [],
                        arrcautraloi: [],
                        socauhoi: 0
                    }
                }));
            } finally {
                setLoading(prev => ({
                    ...prev,
                    [type]: false
                }));
            }
        }
    }

    const toggleShowQuestion = (examType) => {
        setshowQuestion(prev => ({
            ...prev,
            [examType]: !prev[examType]
        }));
    }

    const handleQuestionClick = (examType, item, index) => {
        // Dạng thi Nói: không cho phép chuyển câu qua menu
        if (type === 'NOI' || examType === 'NOI') return;

        if (examType === type) {
            // Nếu cùng dạng thi hiện tại, gọi openMenuLeft như cũ (không đóng menu)
            openMenuLeft(item, index);
        } else {
            // Nếu khác dạng thi, chuyển sang dạng thi đó và đóng menu
            localStorage.setItem('typeExam', examType);
            onClose();
            // Navigate đến route tương ứng
            const route = getExamTypeRoute(examType);
            window.location.href = route;
        }
    }
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!visible) return null;

    return (
        <div className={`navmenu-panel ${isMobile ? 'mobile' : ''}`}>
            <div className="navmenu-header d-flex justify-content-between align-items-center">
                <div className="fw-bold">Question List</div>
                <Button icon="pi pi-times" className="p-button-text p-button-rounded" onClick={() => onClose()} />
            </div>
            <div className="navmenu-body">
                <TabView>
                    <TabPanel header="All">
                        <div className="navmenu-content">
                            {EXAM_TYPES.filter(t => {
                                if (examMode === 'speaking_only') return t.code === 'NOI';
                                if (examMode === 'full_exam') return t.code !== 'NOI';
                                return true;
                            }).map((examType) => {
                                const examDataForType = examData[examType.code] || { arrIdQuestion: [], arrcautraloi: [], socauhoi: 0 };
                                const arrIdQuestion = examDataForType.arrIdQuestion || [];
                                const arrcautraloi = examDataForType.arrcautraloi || [];
                                const socauhoi = examDataForType.socauhoi || 0;
                                const isLoading = loading[examType.code];
                                const isCurrentType = examType.code === type;
                                const isExpanded = isCurrentType && showQuestion[examType.code];
                                const isCompleted = isExamTypeCompleted(examType.code);

                                return (
                                    <div
                                        key={examType.code}
                                        className="mt-3"
                                        style={{
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '10px',
                                            backgroundColor: '#ffffff',
                                            boxShadow: '0 4px 10px rgba(15, 23, 42, 0.06)',
                                            opacity: (isCompleted && !isCurrentType) ? 0.7 : 1
                                        }}
                                    >
                                        <div
                                            className="d-flex align-items-center"
                                            style={{
                                                padding: '10px 12px',
                                                borderBottom: isExpanded && arrIdQuestion.length > 0 ? '1px solid #e5e7eb' : 'none',
                                                background: isCurrentType ? 'rgba(35, 8, 90, 0.05)' : 'transparent',
                                                borderLeft: isCurrentType ? '4px solid #23085a' : 'none',
                                                borderRadius: isCurrentType ? '0 10px 10px 0' : '10px'
                                            }}
                                        >
                                            <div style={{ width: '80%' }}>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        fontSize: 14,
                                                        color: isCurrentType ? '#23085a' : '#111827',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px'
                                                    }}
                                                >
                                                    {renderTitle(examType.code)}
                                                    {/* {isCompleted && (
                                                        <span style={{ 
                                                            fontSize: '10px', 
                                                            padding: '2px 6px', 
                                                            backgroundColor: '#10b981', 
                                                            color: 'white', 
                                                            borderRadius: '12px',
                                                            fontWeight: 500
                                                        }}>
                                                            Done
                                                        </span>
                                                    )} */}
                                                </div>
                                                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                                                    {isCurrentType ? (
                                                        isLoading ? 'Loading...' : `${socauhoi} Questions`
                                                    ) : (
                                                        isCompleted ? 'Finished' : 'Not available'
                                                    )}
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ width: '20%', alignItems: 'center' }}>
                                                <div
                                                    onClick={() => !isLoading && isCurrentType && toggleShowQuestion(examType.code)}
                                                    style={{
                                                        backgroundColor: '#e7e6f1',
                                                        borderRadius: '4px',
                                                        cursor: (isLoading || !isCurrentType) ? 'not-allowed' : 'pointer',
                                                        padding: '2px 5px',
                                                        opacity: isLoading ? 0.5 : 1
                                                    }}
                                                >
                                                    {isCurrentType ? (
                                                        arrIdQuestion.length === 0 ? (
                                                            <FaLock />
                                                        ) : (
                                                            <>
                                                                {isExpanded ? <FaMinus /> : <FaPlus />}
                                                            </>
                                                        )
                                                    ) : (
                                                        <FaLock />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {isExpanded && !isLoading && arrIdQuestion.length > 0 &&
                                            <div style={{ padding: '6px 10px 10px 10px' }}>
                                                {arrIdQuestion.map((item, index) => {
                                                    const isBook = (typeof item === 'object')
                                                        ? arrBook.some(b => typeof b === 'object' && b.idnhom === item.idnhom)
                                                        : arrBook.some(b => typeof b !== 'object' && String(b) === String(item));

                                                    const isCurrentQuestion = isCurrentType && indexDF === index;
                                                    const isSeen = isCurrentType && index < indexDF; // Đã xem qua
                                                    const isUnseen = !isCurrentType || index > indexDF; // Chưa xem hoặc khác dạng thi

                                                    // Kiểm tra xem câu hỏi đã được trả lời chưa
                                                    const answerValue = arrcautraloi && arrcautraloi[index];
                                                    const isAttempted = answerValue !== undefined &&
                                                        answerValue !== null &&
                                                        answerValue !== "" &&
                                                        answerValue !== "0" &&
                                                        answerValue !== 0 &&
                                                        !(Array.isArray(answerValue) && answerValue.length === 0) &&
                                                        !(typeof answerValue === 'object' && Object.keys(answerValue).length === 0);

                                                    // Xác định trạng thái xem
                                                    let viewStatus = "Unseen";
                                                    if (isCurrentQuestion) {
                                                        viewStatus = "Current";
                                                    } else if (isSeen) {
                                                        viewStatus = "Seen";
                                                    } else if (isUnseen) {
                                                        viewStatus = "Unseen";
                                                    }

                                                    return (
                                                        <div
                                                            onClick={() => type !== 'NOI' && handleQuestionClick(examType.code, item, index)}
                                                            className={`mt-3 ${type !== 'NOI' ? 'cursor-pointer' : ''}`}
                                                            key={index}
                                                            style={{
                                                                padding: '8px 10px',
                                                                backgroundColor: isCurrentQuestion ? 'rgb(229 229 229)' : '#ffffff',
                                                                borderRadius: '8px',
                                                                border: isCurrentType ? '1px solid rgb(171 185 192)' : '1px solid #e5e7eb',
                                                                opacity: isCurrentType ? 1 : 0.9,
                                                                cursor: type === 'NOI' ? 'not-allowed' : 'pointer'
                                                            }}
                                                        >
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <span style={{ fontWeight: 600, fontSize: 13 }}>
                                                                    {index < 9 ? ("0" + (index + 1)) : (index + 1)}
                                                                </span>
                                                                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                                    {isBook && <FaBookmark size={16} color="#23085a" />}
                                                                    {type === 'NOI' && <FaLock size={14} color="#9ca3af" />}
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between" style={{ marginTop: 2 }}>
                                                                <div style={{ fontSize: 11, color: '#6b7280' }}>
                                                                    {viewStatus}
                                                                </div>
                                                                <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                                                    {isAttempted ? "Attempted" : "Not Attempted"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </TabPanel>
                    <TabPanel header={`Bookmarked (${arrBookNew.length})`}>
                        <div className="navmenu-content">
                            {arrBookNew.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                    No bookmarked questions
                                </div>
                            ) : (
                                arrBookNew.map((item, index) => {
                                    const itemExamType = item.examType || type;
                                    return (
                                        <div
                                            onClick={() => handleQuestionClick(itemExamType, item.value, item.index)}
                                            className="mt-3 cursor-pointer"
                                            key={index}
                                            style={{
                                                padding: '8px',
                                                backgroundColor: (itemExamType === type && indexDF == item.index) ? '#e7e6f1' : 'white',
                                                borderRadius: '8px',
                                                border: '1px solid #e7e6f1'
                                            }}
                                        >
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <strong>{item.index < 9 ? ("0" + (item.index + 1)) : (item.index + 1)}</strong>
                                                    <span style={{ fontSize: '11px', marginLeft: '8px', color: '#6b7280' }}>
                                                        ({renderTitle(itemExamType)})
                                                    </span>
                                                </div>
                                                <FaBookmark size={20} />
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <div style={{ fontSize: '12px' }}>Seen</div>
                                                <div style={{ fontSize: '12px' }}>Bookmarked</div>
                                            </div>
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
}
